import { render, staticRenderFns } from "./SidebarMenuIcon.vue?vue&type=template&id=03b7c4b9&scoped=true"
import script from "./SidebarMenuIcon.vue?vue&type=script&lang=js"
export * from "./SidebarMenuIcon.vue?vue&type=script&lang=js"
import style0 from "./SidebarMenuIcon.vue?vue&type=style&index=0&id=03b7c4b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b7c4b9",
  null
  
)

export default component.exports